(() => {
  const article = document.querySelector('[data-mah-authority-article]');
  if (!article) return;

  const body = article.querySelector('[data-mah-article-body]');
  const toc = article.querySelector('[data-mah-article-toc]');
  const progress = document.querySelector('[data-mah-article-progress]');

  if (body && toc) {
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
    const used = new Set();

    headings.forEach((heading, index) => {
      let slug = heading.id || heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      if (!slug) slug = `section-${index + 1}`;
      let unique = slug;
      let suffix = 2;
      while (used.has(unique) || document.getElementById(unique)) {
        if (heading.id === unique) break;
        unique = `${slug}-${suffix++}`;
      }
      heading.id = unique;
      used.add(unique);

      const link = document.createElement('a');
      link.href = `#${unique}`;
      link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      link.textContent = heading.textContent.trim();
      toc.appendChild(link);
    });

    if (headings.length) {
      const panel = toc.closest('[data-mah-toc-panel]');
      if (panel) panel.hidden = false;
    }
  }

  if (progress && body) {
    const updateProgress = () => {
      const rect = body.getBoundingClientRect();
      const start = window.scrollY + rect.top - window.innerHeight * 0.2;
      const end = start + body.offsetHeight - window.innerHeight * 0.65;
      const value = Math.min(1, Math.max(0, (window.scrollY - start) / Math.max(1, end - start)));
      progress.style.width = `${value * 100}%`;
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  }
})();
